/* eslint-disable */
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams, Link, useLocation, Navigate } from 'react-router-dom';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { MdOutlineEdit } from 'react-icons/md';
import { CiTrash } from 'react-icons/ci';
import { FaRegCopy } from 'react-icons/fa';
import InfoTooltip from '../components/InfoTooltip';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  CircularProgress,
} from '@mui/material';
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
// components
import Swal from 'sweetalert2';
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import appConfig from '../config';
import USERLIST from '../_mock/user';
import {
  deleteCleaner,
  deleteContractor,
  deleteSpecialAccess,
  deleteUser,
  getAllCleaner,
  getAllContractor,
  // getAllContracts,
  getAllSpecialAcess,
  getBnbList,
  getUsers,
} from '../helper/backend_helper';

// ----------------------------------------------------------------------
// const users = [
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
//   {
//     first: 'John',
//     last: 'wick',
//     email: 'johnwick@example.com',
//     phoneNo: '123-45-6781',
//   },
// ];

const TABLE_HEAD = [
  { id: '', label: 'Contractor Name', alignRight: true },
  { id: '', label: 'Percentage', alignRight: true },
  { id: '', label: 'Contract Duration', alignRight: true },
  { id: '', label: 'Owner Type', alignRight: true },
  { id: '', label: 'First Name', alignRight: true },
  { id: '', label: 'Last Name', alignRight: true },
  { id: '', label: 'Address', alignRight: true },
  { id: '', label: 'City', alignRight: true },
  { id: '', label: 'Phone No', alignRight: true },
  { id: '', label: 'Email', alignRight: true },
  { id: '', label: 'Document Type', alignRight: true },
  { id: '', label: 'Document No', alignRight: true },
  { id: '', label: 'Document Issue Date', alignRight: true },
  { id: '', label: 'Document Expiry Date', alignRight: true },
  { id: '', label: 'Document Image', alignRight: true },
  { id: '', label: 'Fiscal Code Image', alignRight: true },
  { id: '', label: 'Company Name', alignRight: true },
  { id: '', label: 'VAT Number', alignRight: true },
  { id: '', label: 'Company Fiscal Code', alignRight: true },
  { id: '', label: 'REA Number', alignRight: true },
  { id: '', label: 'Company Type', alignRight: true },
  { id: '', label: 'Company Reg Doc Image', alignRight: true },

  { id: '', label: 'Property Name', alignRight: true },
  { id: '', label: 'OwnerShip Type', alignRight: true },
  { id: '', label: 'CIN', alignRight: true },
  { id: '', label: 'CIS', alignRight: true },
  { id: '', label: 'Property Address', alignRight: true },
  { id: '', label: 'Property Postal Code', alignRight: true },

  { id: '', label: 'Visura Catastale Image', alignRight: true },
  { id: '', label: 'Visura Catastale Number', alignRight: true },
  { id: '', label: 'Visura Catastale Date', alignRight: true },

  { id: '', label: 'Account Holder', alignRight: true },
  { id: '', label: 'Bank', alignRight: true },
  { id: '', label: 'IBAN', alignRight: true },

  { id: '', label: 'Signed Contract Image', alignRight: true },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user.firstName.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        _user.lastName.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ContractsList() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [clickedRowData, setClickedRowData] = useState(null);
  const [users, setUsers] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      setLoading(true);
      // const usersResponse = await getAllContracts();
      // setUsers(usersResponse?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const [loading, setLoading] = useState(false);

  const handleDelete = async (_id) => {
    try {
      const confirmed = await Swal.fire({
        icon: 'warning',
        title: 'Are you sure you want to delete this Contractor?',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
      });

      if (confirmed.isConfirmed) {
        const headers = {
          headers: {
            'Content-Type': 'application/json',
          },
        };

        const response = await deleteContractor(_id, headers);
        Swal.fire({
          icon: 'success',
          title: 'Contractor deleted successfully',
        });
        fetchData();
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'An error occurred while deleting',
      });
    }
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

  const filteredUsers = applySortFilter(users, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;
  // const encodedData = encodeURIComponent(JSON.stringify(clickedRow));
  return (
    <>
      <Helmet>
        <title> contracts </title>
      </Helmet>

      <Card sx={{ p: 3 }}>
        <Stack mb={3} direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4">Contracts List{' '}<InfoTooltip width={20} title="The full record of submitted property-management contracts, showing every detail a contractor filled in. Each row covers owner and company information, property and cadastral data, identity documents, bank details and the signed contract file. Use this page to review completed contracts and open the uploaded document images via their links." /></Typography>

          {/* <Button
                sx={{
                  boxShadow: 'none',
                  backgroundColor: '#1E3A5F',
                  '&:hover': {
                    backgroundColor: '#1E3A5F',
                    boxShadow: 'none',
                  },
                }}
                variant="contained"
                endIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => navigate('/contractorList/add_contractor')}
              >
                Add Contractor
              </Button> */}
        </Stack>

        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={users.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                  const {
                    _id,
                    contractorId,
                    owner_type,
                    first_name,
                    last_name,
                    address,
                    city,
                    phone,
                    email,
                    document_type,
                    document_number,
                    doc_issue_date,
                    doc_expiry_date,
                    doc_image,
                    fiscal_code_image,
                    company_name,
                    vat_number,
                    company_fiscal_code,
                    rea_number,
                    company_type,
                    company_registration_doc_image,
                    property_name,
                    ownership_type,
                    CIN,
                    CIS,
                    property_address,
                    property_postal_code,
                    visura_catastale_image,
                    visura_catastale_number,
                    visura_catastale_date,
                    account_holder,
                    bank,
                    IBAN,
                    signed_contact_image,
                  } = row;

                  return (
                    <TableRow hover key={_id}>
                      <TableCell component="th" scope="row">
                        {/* <Avatar alt={name} src={`${appConfig.FILe_URL}${directory}/${image}`} /> */}
                        {/* <Avatar alt={name} src={image} /> */}
                        <Typography align="left" variant="subtitle2" noWrap>
                          {contractorId.name}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">{contractorId.percentage} %</TableCell>
                      <TableCell align="left">{contractorId.contractDuration}</TableCell>
                      <TableCell align="left">{owner_type}</TableCell>
                      <TableCell align="left">{first_name}</TableCell>
                      <TableCell align="left">{last_name}</TableCell>
                      <TableCell align="left">{address}</TableCell>
                      <TableCell align="left">{city}</TableCell>
                      <TableCell align="left">{phone}</TableCell>
                      <TableCell align="left">{email}</TableCell>
                      <TableCell align="left">{document_type}</TableCell>
                      <TableCell align="left">{document_number}</TableCell>
                      <TableCell align="left">{doc_issue_date}</TableCell>
                      <TableCell align="left">{doc_expiry_date}</TableCell>
                      <TableCell align="left">
                        {doc_image ? (
                          <a
                            href={`${appConfig.FILE_URL}/${doc_image}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              cursor: 'pointer',
                              color: '#009245',
                              textDecoration: 'underline',
                            }}
                          >
                            Link
                          </a>
                        ) : (
                          'No file available'
                        )}
                      </TableCell>

                      <TableCell align="left">
                        {fiscal_code_image? (
                          <a
                            href={`${appConfig.FILE_URL}/${fiscal_code_image}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              cursor: 'pointer',
                              color: '#009245',
                              textDecoration: 'underline',
                            }}
                          >
                            Link
                          </a>
                        ) : (
                          'No file available'
                        )}
                      </TableCell>
                      <TableCell align="left">{company_name}</TableCell>
                      <TableCell align="left">{vat_number}</TableCell>
                      <TableCell align="left">{company_fiscal_code}</TableCell>
                      <TableCell align="left">{rea_number}</TableCell>
                      <TableCell align="left">{company_type}</TableCell>
                      <TableCell align="left">
                        {company_registration_doc_image? (
                          <a
                            href={`${appConfig.FILE_URL}/${company_registration_doc_image}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              cursor: 'pointer',
                              color: '#009245',
                              textDecoration: 'underline',
                            }}
                          >
                            Link
                          </a>
                        ) : (
                          'No file available'
                        )}
                      </TableCell>
                      <TableCell align="left">{property_name}</TableCell>
                      <TableCell align="left">{ownership_type}</TableCell>
                      <TableCell align="left">{CIN}</TableCell>
                      <TableCell align="left">{CIS}</TableCell>
                      <TableCell align="left">{property_address}</TableCell>
                      <TableCell align="left">{property_postal_code}</TableCell>
                      <TableCell align="left">
                        {visura_catastale_image? (
                          <a
                            href={`${appConfig.FILE_URL}/${visura_catastale_image}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              cursor: 'pointer',
                              color: '#009245',
                              textDecoration: 'underline',
                            }}
                          >
                            Link
                          </a>
                        ) : (
                          'No file available'
                        )}
                      </TableCell>
                      <TableCell align="left">{visura_catastale_number}</TableCell>
                      <TableCell align="left">{visura_catastale_date}</TableCell>
                      <TableCell align="left">{account_holder}</TableCell>
                      <TableCell align="left">{bank}</TableCell>
                      <TableCell align="left">{IBAN}</TableCell>
                      <TableCell align="left">
                        {signed_contact_image? (
                          <a
                            href={`${appConfig.FILE_URL}/${signed_contact_image}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              cursor: 'pointer',
                              color: '#009245',
                              textDecoration: 'underline',
                            }}
                          >
                            Link
                          </a>
                        ) : (
                          'No file available'
                        )}
                      </TableCell>

                      {/* <TableCell align="center">
                          <Stack
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              gap: 1,
                            }}
                          >
                            <Button
                               onClick={() => navigate('/contractorList/update_contractor', { state: { userData: row } })}
                              sx={{
                                boxShadow: 'none',
                                backgroundColor: '#B5FFD8',
                                color: '#009245',
                                '&:hover': {
                                  backgroundColor: '#B5FFD8',
                                  boxShadow: 'none',
                                },
                              }}
                              size="small"
                              variant="contained"
                              startIcon={<MdOutlineEdit />}
                            >
                              Edit
                            </Button>
                            <Button
                               onClick={(event) => handleDelete(_id)}
                              sx={{
                                boxShadow: 'none',
                                backgroundColor: '#FFC6C6',
                                color: '#DC2626',
                                '&:hover': {
                                  backgroundColor: '#FFC6C6',
                                  boxShadow: 'none',
                                },
                              }}
                              size="small"
                              variant="contained"
                              startIcon={<CiTrash />}
                            >
                              Delete
                            </Button>
                          </Stack>
                        </TableCell>  */}
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={7} />
                  </TableRow>
                )}
                {loading && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={7}>
                      <CircularProgress size="20px" />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >
                        <Typography variant="h6" paragraph>
                          Not found
                        </Typography>

                        <Typography variant="body2">
                          No results found for &nbsp;
                          <strong>&quot;{filterName}&quot;</strong>.
                          <br /> Try checking for typos or using complete words.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[100, 200, 300]}
          component="div"
          count={users.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        {/*     
        <Link
          
          style={{ textDecoration: 'none' }}
          // to={`/dashboard/user-detail/${encodeURIComponent(JSON.stringify(clickedRow))}`}
          to={`/dashboard/user-detail?data=${encodedData}`}
        > */}
        <MenuItem
          onClick={() => navigate('/contractor/contractor-detail', { state: { clickedRowData } })}
          sx={{ color: 'success.main' }}
        >
          <Iconify icon={'eva:image-outline'} sx={{ mr: 2 }} />
          Detail
        </MenuItem>
        {/* </Link> */}
        <MenuItem>
          <Iconify icon={'eva:edit-outline'} sx={{ mr: 2 }} />
          Block
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}
